module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_redefine.js
// module id = 39
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/core-js/library/modules/_redefine.js